import { Modal, useModals } from 'almanac-ui/Modal'
import { useEffect, useState } from 'react'
import Styles from '../DesignWizardField.module.scss'
import { HighDetailedSource } from 'blaze-ui/icons/24'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { Button } from 'blaze-ui/Button'
import { Plus } from 'blaze-ui/icons'
import { KnowledgeBaseSourceMaterial } from 'types'
import { useOpenSourceMaterialModal } from 'hooks/useOpenSourceMaterialModal'

interface Props {
  onSourceMaterialsSelect: (tones: KnowledgeBaseSourceMaterial[]) => void
  initialSourceMaterials: KnowledgeBaseSourceMaterial[]
  sourceMaterials: KnowledgeBaseSourceMaterial[]
  onHandleSourceMaterialSuccess: () => void
}

export const SourceMaterialsModal = ({
  sourceMaterials,
  onSourceMaterialsSelect,
  initialSourceMaterials,
  onHandleSourceMaterialSuccess,
}: Props) => {
  const [selectedSourceMaterials, setSelectedSourceMaterials] =
    useState<KnowledgeBaseSourceMaterial[]>(initialSourceMaterials)
  const { closeModal } = useModals()
  const openSourceMaterialModal = useOpenSourceMaterialModal()

  useEffect(() => setSelectedSourceMaterials(initialSourceMaterials), [initialSourceMaterials]) // eslint-disable-line react-hooks/exhaustive-deps

  const openAddSourceMaterialModal = () => {
    openSourceMaterialModal({ onHandleSourceMaterialSuccess }, { newStack: true })
  }

  const handleSubmit = () => {
    onSourceMaterialsSelect(selectedSourceMaterials)
    closeModal()
  }

  return (
    <Modal.Root onPressOutside={closeModal}>
      <Modal.Header
        title={
          <div className={Styles.title}>
            <HighDetailedSource size={32} />
            Source Materials
          </div>
        }
        actions={
          <Button variant="tertiary" frontIcon={Plus} onPress={openAddSourceMaterialModal}>
            Create New
          </Button>
        }
      />
      <Modal.Content>
        <Heading level={5}>Select up to 3 source materials</Heading>
        <div className={cx(Styles.grid, Styles.sourceMaterials)}>
          {sourceMaterials?.map((material) => (
            <Checkbox
              size="lg"
              key={material.id}
              className={Styles.checkbox}
              isSelected={selectedSourceMaterials.includes(material)}
              isDisabled={!selectedSourceMaterials.includes(material) && selectedSourceMaterials.length === 3}
              onChange={() => {
                const materialsSet = new Set(selectedSourceMaterials)
                materialsSet.has(material) ? materialsSet.delete(material) : materialsSet.add(material)
                setSelectedSourceMaterials(Array.from(materialsSet).slice(0, 3))
              }}
            >
              <Text variant="smallList" color="var(--dark-80)" lineClamp={1}>
                {material.name}
              </Text>
            </Checkbox>
          ))}
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={closeModal} variant="tertiary" size="lg">
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={handleSubmit} size="lg" variant="primary">
            {!selectedSourceMaterials.length ? "Don't Use Source Materials" : `Use Selected Source Materials`}
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
